export default "__VITE_ASSET__394ce273__"